import React from 'react'
import { Form, Image } from 'react-bootstrap'
import QuillTextEditor from '../../../../components/QuillTextEditor'

const Section2Form = ({ 
  fields, 
  onInputChange, 
  upload, 
  showAlert, 
  isUploading, 
  validationErrors, 
  setValidationErrors, 
  section 
}) => {
  const handleFileUpload = async (file) => {
    try {
      const res = await upload(file)
      if (res?.url) {
        onInputChange(section, 'mainImage', res.url)
      }
    } catch (err) {
      showAlert('File upload failed.', 'danger')
    }
  }

  return (
    <>
      <Form.Group className='mb-3'>
        <Form.Label>
          Heading <span className='text-danger'>*</span>
        </Form.Label>
        <Form.Control
          type='text'
          value={fields.heading}
          onChange={(e) => {
            onInputChange(section, 'heading', e.target.value)
            if (validationErrors[`${section}.heading`]) {
              setValidationErrors((prev) => ({
                ...prev,
                [`${section}.heading`]: undefined,
              }))
            }
          }}
          isInvalid={!!validationErrors[`${section}.heading`]}
        />
        {validationErrors[`${section}.heading`] && (
          <Form.Control.Feedback type='invalid'>
            {validationErrors[`${section}.heading`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label>
          Description <span className='text-danger'>*</span>
        </Form.Label>
        {/* <Form.Control
          as='textarea'
          rows={4}
          value={fields.description}
          onChange={(e) => {
            onInputChange(section, 'description', e.target.value)
            if (validationErrors[`${section}.description`]) {
              setValidationErrors((prev) => ({
                ...prev,
                [`${section}.description`]: undefined,
              }))
            }
          }}
          isInvalid={!!validationErrors[`${section}.description`]}
        /> */}
        <QuillTextEditor 
          value={fields.description}
          onChange={(value) => {
            onInputChange(section, 'description', value)
            if (validationErrors[`${section}.description`]) {
              setValidationErrors((prev) => ({
                ...prev,
                [`${section}.description`]: undefined,
              }))
            }
          }}
        />

        {validationErrors[`${section}.description`] && (
          <Form.Control.Feedback type='invalid'>
            {validationErrors[`${section}.description`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label>Main Image</Form.Label>
        <Form.Control
          type='file'
          accept='image/*'
          onChange={(e) =>
            e.target.files?.[0] && handleFileUpload(e.target.files[0])
          }
        />
        {isUploading && (
          <div className='text-muted small mt-1'>Uploading...</div>
        )}
        {fields.mainImage && (
          <div className='mt-2'>
            <Image
              src={fields.mainImage}
              alt='Main Image Preview'
              thumbnail
              style={{ maxWidth: '200px' }}
            />
          </div>
        )}
      </Form.Group>
    </>
  )
}

export default Section2Form
